document.addEventListener('alpine:init', () => {
  const selector_cart_link = '.header-controls__cart';
  const selector_cart_count = '[data-header-cart-count]';
  Alpine.data('CartDrawer', () => ({
    special_upsell_handle: null,
    cart: {
      items: [], 
      item_count: 0, 
      total_price: 0,
      token: 'initial'
    },
    flags: {
      open: false,
      empty: true,
      enable_recommended_upsells: false,
      discount_code_applied: false
    },
    currency_code: '',
    recommended_products: [],
    upsell_limit: 2,
    init() {
      this.InitWatchers();
      this.InitSelf();
      this.InitEventHandlers();
    },
    InitSelf() {
      let am = this;
      am.currency_code = am.$el.dataset.currency_code;
      am.UpdateCart();
      am.flags.enable_recommended_upsells = am.$el.dataset.enable_recommended_upsells == 'true';
      am.upsell_limit = parseInt(am.$el.dataset.upsell_limit);
      am.special_upsell_handle = am.$el.dataset.special_upsell_handle;
    },
    InitWatchers() {
      let am = this;
      am.$watch('flags.open', () => {
        document.body.classList.toggle('is-cart-open', am.flags.open);
      });

      am.$watch('cart', am.UpdateFlags.bind(am));
      am.$watch('cart', Alpine.debounce(() => {
        if (am.cart.token == 'initial') return;
        am.e_LoadRecommendedProducts();
      }, 0));

      let cart_open_events = ['cart:modified', 'cart:drawer:open'];
      cart_open_events.forEach((event_type) => {
        document.addEventListener(event_type, async (e) => {
          // console.log(e);
          await am.UpdateCart();
          am.flags.open = true;
        });  
      });

      u_ObserveMutation(selector_cart_link, {}, async(m) => {
        // console.log('mutation', m);
        await am.UpdateCart();
        am.flags.open = true;
      });

      document.addEventListener('cart:drawer:close', () => {
        am.flags.open = false;
      });
    },
    InitEventHandlers() {
      let am = this;
      let $toggles = [
        ...document.querySelectorAll(selector_cart_link)
      ];
      // console.log($toggles)
      $toggles.forEach(($toggle) => {
        $toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          am.flags.open = true;
        });
      });
    },
    FormatMoney(value) {
      return u_FormatMoney(value, '${{amount}}');
    },
    UpdateFlags() {
      let am = this;
      am.flags.empty = am.cart.item_count == 0;
      am.flags.discount_code_applied = am.cart.cart_level_discount_applications?.find(item => item.title == am.discount_code) !== undefined;
    },
    async UpdateCart() {
      let am = this;
      let cart = await fetch('/cart.js').then(res => res.json());
      am.cart.items = [];
      am.$nextTick(() => {
        am.cart = {...cart};
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: { cart }}));  
      });
      document.querySelectorAll(selector_cart_count).forEach(($el) => {
        $el.textContent = cart.item_count;
        $el.dataset.cart_item_count = cart.item_count;
      });
    },
    async e_UpdateLineQuantity(item) {
      let am = this;
      let item_updates = {}
      item_updates[item.key] = item.quantity;
      // console.log(item, item_updates);
      await u_UpdateCartItems(item_updates);
      am.UpdateCart();
    },
    e_AnimateIcon(e) {
      // remove fa-plus, fa-minus class
      let $icon = e.currentTarget.querySelector('.fa');
      $icon.classList.remove('fa-plus', 'fa-minus', 'fa-trash');
      $icon.classList.add('fa-solid', 'fa-sync-alt', 'fa-spin');
    },
    e_Checkout() {
      window.location.href = '/checkout';
    },
    async e_LoadRecommendedProducts(e) {
      // console.log(e);
      let am = this;
      if (!am.flags.enable_recommended_upsells) return;

      let section_id = 'cm--cart-drawer';
      let res = await fetch(`/?sections=${section_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      let data = await res.json();
      let html = data[section_id];
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');
      let $upsell_section = doc.querySelector('.cart-upsells');
      if (!$upsell_section) return;
      this.$el.querySelector('.cart-upsells').replaceWith($upsell_section);
    },
    async e_ToggleCoupon() {
      await fetch(`/discount/${this.discount_code}`);
      document.dispatchEvent(new CustomEvent('cart:modified'));
    },
    async e_UpdateCartNote(e) {
      // console.log(e);
      // console.log('updating cart note...');
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: e.target.value })
      }).then(res => res.json());
    }
  }));

  Alpine.data('CartProgressBars', () => ({
    pbars: {
      free_product: {
        enabled: true,
        threshold: 4500,
        progress: 0
      },
      free_ship: {
        enabled: true,
        threshold: 10000,
        progress: 0
      }
    },
    init() {
      this.InitSelf();
      this.InitWatchers();
      this.UpdateProgress();
    },
    InitSelf() {
      let am = this;
      let freeShipThreshold = parseFloat(am.$el.dataset.freeShipThreshold);
      // hard coded for other countries
      switch(am.currency_code) {
        case 'USD':
          freeShipThreshold = 35;
          break;
        case 'AUD':
          freeShipThreshold = 50;
          break;
        case 'CAD':
          freeShipThreshold = 44;
          break;
        case 'EUR':
          freeShipThreshold = 28;
          break;
        case 'NZD':
          freeShipThreshold = 53;
          break;
      }
      am.pbars.free_ship.threshold = freeShipThreshold * 100;
    },
    InitWatchers() {
      let am = this;
      am.$watch('cart', am.UpdateProgress.bind(am));
    },
    UpdateProgress() {
      let am = this;
      // free shipping logic
      let subscription_items = am.cart.items.filter(item => !!item.selling_plan_allocation);
      let free_ship_progress = subscription_items.length ? 100 : (am.cart.total_price * 100 / am.pbars.free_ship.threshold);
      // console.log(am.pbars.free_ship.progress)
      am.pbars.free_ship.progress = free_ship_progress >= 100 ? 100 : free_ship_progress;
    }
  }));

  Alpine.data('CartLineItem', () => ({
    line_item: null,
    product: {},
    upsell: null,
    cache: {},
    flags: {
      is_onetime: true,
      product_offers_subscription: false
    },
    init() {
      let am = this;
      am.InitWatchers();
      am.$nextTick(am.InitSelf.bind(am));
    },
    async InitSelf() {
      let am = this;
      am.cache.$cart_drawer = am.$el.closest('.cart_drwr');
      am.line_item = JSON.parse(am.$el.dataset.lineitem);
      am.CheckFlags();
      let product = await fetch(`/products/${am.line_item.handle}.js`).then(res => res.json());
      am.product = {...am.product, ...product};
      // console.log(p_res, am.product)
    },
    InitWatchers() {
      let am = this;
      am.$watch('product', () => {
        am.CheckFlags();
      });
    },
    CheckFlags() {
      let am = this;
      if (am.product && am.product.selling_plan_groups) {
        am.flags.product_offers_subscription = am.product.selling_plan_groups.length !== 0;
        am.flags.is_onetime = am.flags.product_offers_subscription && !am.line_item.selling_plan_allocation;  
      }
      am.flags.enable_recommended_upsells = am.cache.$cart_drawer.dataset.enable_recommended_upsells == 'true';
    }
  }));

  Alpine.data('UpsellProductItem', (upsell) => ({
    product: {},
    selected_variant_id: '',
    selected_variant: {featured_image: null},
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.product = JSON.parse(this.$el.dataset.product);
      this.selected_variant_id = parseInt(this.$el.dataset.selected_variant_id);
    },
    InitWatchers() {
      this.$watch('selected_variant_id', (value) => {
        let variant = this.product.variants.find(v => v.id == parseInt(value));
        this.selected_variant = variant;
      });
    },
    async e_AddUpsell(e) {
      e.currentTarget.classList.add('button--loading');
      e.currentTarget.textContent = 'Adding...';
      if (!this.selected_variant) return;
      let add_item = {
        id: this.selected_variant.id,
        quantity: 1
      };
      await u_AddItemsToCart([add_item]);
      document.dispatchEvent(new CustomEvent('cart:modified'));  
    }
  }));

  Alpine.data('SpecialUpsell', () => ({
    special_upsell_handle: null,
    flags: {
      show_bestseller_tray_upsell: false,
      show_tray_upsell_only: false,
      show_dice_set_only: false
    },
    get TrayItemInCart() {
      if (!this.cart || !this.cart.items) return false;
      let tray_item_in_cart = this.cart.items.find(item => {
        return item.handle == this.special_upsell_handle;
      });
      return tray_item_in_cart || false;
    },
    selected_variants: [],
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.UpdateFlags();
      this.special_upsell_handle = this.$el.dataset.special_upsell_handle;
      this.$nextTick(() => {
        this.selected_variants = [...this.GetSelectedVariants()];
        this.UpdateFlags();
      });
    },
    InitWatchers() {
      document.addEventListener('cart:updated', () => {
        this.$nextTick(() => this.UpdateFlags());
      });
      this.$el.addEventListener('change', (e) => {
        this.$nextTick(() => {
          this.selected_variants = [...this.GetSelectedVariants()];
        });
      });
    },
    UpdateFlags() {
      if (!this.cart || !this.cart.items) return;
      let tray_item_in_cart = this.cart.items.find(item => {
        return item.handle == this.special_upsell_handle;
      });
      let cart_items_dice_sets = this.cart.items.filter(item => {
        return item.product_type.toLowerCase() === 'dice set';
      });
      let dice_sets_count = cart_items_dice_sets.reduce((total, item) => {
        return total + item.quantity;
      }, 0);
      // console.log('dice sets count:', dice_sets_count);

      this.flags.show_bestseller_tray_upsell = dice_sets_count == 1 && !tray_item_in_cart;
      this.flags.show_tray_upsell_only = dice_sets_count >= 2 && !tray_item_in_cart;
      this.flags.show_dice_set_only = !!tray_item_in_cart && dice_sets_count == 1;

      const drawer = this.$el.closest('.cart_drwr');
      if (!drawer) return;
      drawer.classList.toggle('show-bestseller-tray-upsell', this.flags.show_bestseller_tray_upsell);
      drawer.classList.toggle('show-tray-upsell-only', this.flags.show_tray_upsell_only);
      drawer.classList.toggle('show-dice-set-only', this.flags.show_dice_set_only);
    },
    GetSelectedVariants() {
      let $items = [...this.$el.querySelectorAll('.recomm-item')].filter(item => {
        return window.getComputedStyle(item).display !== 'none';
      });
      let variants = $items.map($item => {
        let variant = Alpine.$data($item).selected_variant;
        variant.handle = $item.dataset.handle;
        return variant;
      });
      return variants;
    },
    GetTotalPrice() {
      let total = this.selected_variants.reduce((total, variant) => {
        return total + variant.price;
      }, 0);
      return total;
    },
    GetDiscountedPrice() {
      let items_without_tray = this.selected_variants.filter(variant => {
        return variant.handle != this.special_upsell_handle;
      });
      let total = items_without_tray.reduce((total, variant) => {
        return total + variant.price;
      }, 0);
      return total;
    },
    e_AddUpsellPlusTray (e) {
      e.currentTarget.classList.add('button--loading');
      e.currentTarget.textContent = 'Adding...';
      let items_to_add = this.selected_variants.map(variant => {
        return {
          id: variant.id,
          quantity: 1
        };
      });
      u_AddItemsToCart(items_to_add).then(() => {
        document.dispatchEvent(new CustomEvent('cart:modified'));  
      });
    },
    e_AddTrayOnly (e) {
      e.currentTarget.classList.add('button--loading');
      e.currentTarget.textContent = 'Adding...';
      let tray_variant = this.selected_variants.find(variant => {
        return variant.handle == this.special_upsell_handle;
      });
      if (!tray_variant) return;
      let item_to_add = {
        id: tray_variant.id,
        quantity: 1
      };
      u_AddItemsToCart([item_to_add]).then(() => {
        document.dispatchEvent(new CustomEvent('cart:modified'));  
      });
    }
  }));
});